// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__vw_9K","head":"Table_head__3pD11","col":"Table_col__1WHng"};